const DATE_TYPE = {
  birthday: "birthday",
  anniversary: "anniversary",
  valentines: "valentine's Day",
  mothersDay: "mother's Day",
  fathersDay: "father's Day",
};

Object.freeze(DATE_TYPE);

export { DATE_TYPE };
